"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _imageSrc = require("../../lib/imageSrc");
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a Media Column
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A Media Column
 */
function MediaColumn(props) {
  var _extractedFields$Head;
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var alignmentParamKey = (_extractedFields$Head = extractedFields.HeaderAlignment) !== null && _extractedFields$Head !== void 0 && _extractedFields$Head.fields.Key.value ? extractedFields.HeaderAlignment.fields.Key.value : 'Center';
  var clsName = alignmentParamKey === 'Center' ? 'mm-text-center' : "".concat(extractedFields.HeaderAlignment.fields.Value.value);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container media-column"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: 'basic'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, !(0, _lodash.isEmpty)(extractedFields.Header.value) && (0, _titleHeadTag.headTagTitle)(extractedFields.Header, "".concat(clsName, " card-title mm-spacing--minor"), extractedFields.HeaderSize.value), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, extractedFields.MediaList.map((mlist, key) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-".concat((0, _utils.columnWidth)(extractedFields.MediaList.length, 3), " \n                col-border mm-text-").concat(extractedFields.ContentAlignment.value),
      key: key
    }, !(0, _lodash.isEmpty)(mlist.fields.Image.value) && /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-lg-5 col-md-10 col-sm-12"
    }, /*#__PURE__*/_react.default.createElement("picture", {
      className: "mm-img"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(mlist.fields.Image.value),
      alt: mlist.fields.Image.value.alt
    }))), !(0, _lodash.isEmpty)(mlist.fields.Content.value) && /*#__PURE__*/_react.default.createElement("div", {
      className: "col-lg-7 col-md-10 col-sm-12"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, (0, _richTextField.parseHTML)(mlist.fields.Content))))), !(0, _lodash.isEmpty)(mlist.fields.Title.value) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, (0, _richTextField.parseHTML)(mlist.fields.Title))), (0, _lodash.isEmpty)(mlist.fields.Image.value) && /*#__PURE__*/_react.default.createElement("div", null, (0, _richTextField.parseHTML)(mlist.fields.Content)));
  })))));
}
var _default = exports.default = MediaColumn;